"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductTreeNodeList = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const product_tree_node_list_styles_1 = require("./product-tree-node-list.styles");
const product_tree_nodes_1 = require("../../../../../client/product-tree-nodes");
const components_1 = require("../../../../../components");
const generic_1 = require("../../../../../generic");
const utils_1 = require("../../../../../utils");
const comparing_1 = require("../../../../../utils/comparing");
const filtering_1 = require("../../../../../utils/filtering");
const generic_2 = require("../../../../../../generic");
const localization_1 = require("../../../../../../localization");
const store_1 = require("../../../../../../store");
const ProductTreeNodeList = ({ filter, selectedItems, attributesFilter, onSelect, renderSecondaryTitleText, }) => {
    var _a;
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const productTreeId = (0, store_1.useProductTreeId)();
    const { data: productTreeNodes, loading, error } = (0, product_tree_nodes_1.useGetTreeNodesWithValidators)({
        productTreeId,
        filter,
        attributesFilter,
        options: { skip: !filter },
    });
    const [searchTerm, setSearchTerm] = (0, react_1.useState)('');
    const filteredProductTreeNodes = (0, react_1.useMemo)(() => {
        const nodes = searchTerm === ''
            ? productTreeNodes
            : productTreeNodes === null || productTreeNodes === void 0 ? void 0 : productTreeNodes.filter(({ title }) => (0, filtering_1.filterTextCaseInsensitive)(title, searchTerm));
        return [...nodes].sort((a, b) => { var _a, _b; return (0, comparing_1.compareTextCaseInsensitive)((_a = a.title) !== null && _a !== void 0 ? _a : '', (_b = b.title) !== null && _b !== void 0 ? _b : ''); });
    }, [productTreeNodes, searchTerm]);
    const selectedItemsLength = selectedItems.length;
    const isFiltering = searchTerm.trim() !== '';
    const handleSearchChange = (e) => setSearchTerm(e.currentTarget.value);
    const handleSelect = (0, react_1.useCallback)((path, isSelected) => onSelect((0, utils_1.updateUniqueItemListBasedOnValue)(path, isSelected)), [onSelect]);
    const visibleTreeNodeIds = (0, react_1.useMemo)(() => filteredProductTreeNodes.map(({ id }) => id), [filteredProductTreeNodes]);
    const visibleSelectedCount = (0, react_1.useMemo)(() => visibleTreeNodeIds.filter((id) => selectedItems.includes(id)).length, [visibleTreeNodeIds, selectedItems]);
    const handleClearSelection = (0, react_1.useCallback)(() => {
        if (!isFiltering) {
            onSelect([]);
            return;
        }
        const visibleSet = new Set(visibleTreeNodeIds);
        onSelect((prev) => prev.filter((id) => !visibleSet.has(id)));
    }, [isFiltering, onSelect, visibleTreeNodeIds]);
    const handleSelectAll = (0, react_1.useCallback)(() => {
        if (!isFiltering) {
            onSelect(visibleTreeNodeIds);
            return;
        }
        onSelect((prev) => Array.from(new Set([...prev, ...visibleTreeNodeIds])));
    }, [isFiltering, onSelect, visibleTreeNodeIds]);
    const renderedTreeNodes = (0, react_1.useMemo)(() => filteredProductTreeNodes.map((node) => {
        const { id, title } = node;
        return (react_1.default.createElement(product_tree_node_list_styles_1.StyledTreeNodeItem, { key: id }, react_1.default.createElement(generic_1.AttributeCheckbox, { checked: selectedItems.includes(id), onChange: (_e, checked) => handleSelect(id, checked) }), react_1.default.createElement(ui_components_1.Typography, { variant: "body2" }, title), renderSecondaryTitleText === null || renderSecondaryTitleText === void 0 ? void 0 : renderSecondaryTitleText(node)));
    }), [filteredProductTreeNodes, selectedItems, renderSecondaryTitleText, handleSelect]);
    return (react_1.default.createElement(product_tree_node_list_styles_1.StyledTreeNodesSection, null, react_1.default.createElement(product_tree_node_list_styles_1.StyledSearchInput, { onChange: handleSearchChange, value: searchTerm, placeholder: t({ key: 'SEARCH' }), startAdornment: react_1.default.createElement(material_1.InputAdornment, { position: "start" }, react_1.default.createElement(ui_components_1.Icon, { variant: "search", color: ui_components_1.baseColors.primaryBlueMed400, className: "search-icon" })), endAdornment: react_1.default.createElement(material_1.InputAdornment, { position: "end" }, react_1.default.createElement(ui_components_1.Typography, { strong: true, variant: "body2" }, t({ key: 'SELECTED_NODES_COUNT', values: { count: selectedItemsLength, total: (_a = productTreeNodes === null || productTreeNodes === void 0 ? void 0 : productTreeNodes.length) !== null && _a !== void 0 ? _a : 0 } }))) }), react_1.default.createElement("div", { className: "tree-nodes-section-actions" }, react_1.default.createElement(ui_components_1.Button, { rounded: true, color: "primary", disabled: !visibleTreeNodeIds.length || visibleSelectedCount === visibleTreeNodeIds.length, title: t({ key: 'SELECT_ALL' }), onClick: handleSelectAll }), react_1.default.createElement(ui_components_1.Button, { rounded: true, error: true, className: "action-clear-selection", disabled: isFiltering ? !visibleSelectedCount : !selectedItemsLength, title: t({ key: 'CLEAR_SELECTION' }), onClick: handleClearSelection })), react_1.default.createElement("div", { className: "tree-nodes-section-list" }, !loading && !error && !filteredProductTreeNodes.length && (react_1.default.createElement(ui_components_1.Typography, { variant: "body2", className: "no-data-text", color: "textSecondary" }, t({ key: 'NO_DATA_AVAILABLE' }))), renderedTreeNodes, error && (react_1.default.createElement(components_1.Alert, { severity: "error" }, error.message)), loading && (react_1.default.createElement(generic_2.SimpleLoading, null)))));
};
exports.ProductTreeNodeList = ProductTreeNodeList;
exports.default = exports.ProductTreeNodeList;
